exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3kbfE4dPC0ZRe9{display:flex;align-items:center;justify-content:center;text-align:center;padding:0 8px;font-size:12px}._3kbfE4dPC0ZRe9 ._1cGbmLshveNMeu{margin-right:8px}", ""]);

// exports
exports.locals = {
	"feedbackHeaderSection": "_3kbfE4dPC0ZRe9",
	"lozenge": "_1cGbmLshveNMeu"
};